import { t } from 'i18next'
import React, { useState, useEffect } from 'react'

import HeaderTabs from '../OldPortalComponents/HeaderTabs'
import InfoBlock from '../OldPortalComponents/InfoBlock'
import QuizModal from '../QuizModal'
import idealdoc from '../../../assets/images/ideal-doc.png'

import './style.scss'

const QuizDocumentPreview = ({
  documentContent,
  documentType,
  hideTable,
}: any) => {
  const [openIdealDocumentModal, setOpenIdealDocumentModal] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [extractedContentMessage, setExtractedContentMessage] = useState('')

  const tabList = [
    {
      label: 'Text',
    },
    {
      label: 'Table',
    },
  ]

  const onlyText = [
    {
      label: 'Text',
    },
  ]

  useEffect(() => {
    if (documentType === 'processed') {
      setExtractedContentMessage('Questions were extracted successfully. ')
    } else if (documentType === 'original' && documentContent) {
      setExtractedContentMessage('We could not extract any questions. ')
    } else if (documentType === 'original' && !documentContent) {
      setExtractedContentMessage(
        'We could not process the content. Please try with another document. ',
      )
    }
  }, [])

  return (
    <div className="extract-quiz-info">
      <HeaderTabs
        selectedIndex={selectedIndex}
        onChange={(index: any) => setSelectedIndex(index)}
        tabList={hideTable ? onlyText : tabList}
      />
      {selectedIndex === 0 && (
        <div className="text-preview-content">
          <InfoBlock>
            <span className="highlighted-content">
              {extractedContentMessage}
            </span>
            {documentContent && (
              <React.Fragment>
                {t('Review the extracted content below.')}{' '}
                <a
                  href="javascript:void(0);"
                  onClick={() => {
                    setOpenIdealDocumentModal(true)
                  }}
                >
                  {t('See ideal document example')}
                </a>
              </React.Fragment>
            )}
            {!documentContent && (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  setOpenIdealDocumentModal(true)
                }}
              >
                {t('Check out how you can format your document.')}
              </a>
            )}
          </InfoBlock>

          <div
            className="quiz-info-extract"
            dangerouslySetInnerHTML={{
              __html: `<pre class='pre-quiz-info-extract'>${documentContent}</pre>`,
            }}
          ></div>

          <QuizModal
            openModal={openIdealDocumentModal}
            onRequestClose={() => {
              setOpenIdealDocumentModal(false)
            }}
          >
            <img
              className="img-responsive"
              src={idealdoc}
              alt="Ideal document description"
            />
          </QuizModal>
        </div>
      )}
      {selectedIndex === 1 && (
        <div className="table-preview-content">
          <div className="initial-screen">
            {t('Table extraction is no longer available in this view.')}
          </div>
        </div>
      )}
    </div>
  )
}

export default QuizDocumentPreview
